// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"e2990ea3","177":"e2990ea3","907":"e2990ea3"}[chunkId] + ".chunk.css";
};